var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.875,
    height: 17.876,
    viewBox: "0 0 17.875 17.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_circle_filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#97c634;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.938,0A8.938,8.938,0,1,1,0,8.938,8.938,8.938,0,0,1,8.938,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.332,11.749.144,8.56a.49.49,0,0,1,0-.694l.694-.694a.49.49,0,0,1,.694,0L3.678,9.321l4.6-4.6a.49.49,0,0,1,.694,0l.694.694a.491.491,0,0,1,0,.694l-5.64,5.64A.49.49,0,0,1,3.332,11.749Z",
    transform: "translate(4.114 0.747)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check_circle_filled.e8ec9f8a632a93f44e8019f292bc30fc.svg";
export { ForwardRef as ReactComponent };